import i18nUtil from "../../../../locales/I18nUtil";

const state = {
  complPaperCount: null, //완료된 업무 카운트
  ingPaperCount: null, //진행중 업무 카운트
  pausePaperCount: null, //일시중지 업무 카운트
  totalPaperCount: null, //완료된 업무 카운트
  decisionCount: null, //의사 결정 요청 카운트
  projectList: [], //과제 리스트
  projectInfo: {
    cogroup: {},
    project: {}
  }, // 클릭한 프로젝트 정보
  projectListAll: [], // 과제 상세에서의 모든 과제 리스트
  projectMemberList: [], // 과제 멤버
  projectMemberCount: 0, // 과제 멤버 카운트
  projectCommentCount: 0, // 과제 의견 카운트
  projectInvitationMemberList: [], // 과제 초대 멤버
  projectInvitationMemberCount: 0, // 과제 초대 멤버 카운트
  projectOkrLinkList: [],
  projectOkrLinkCount: 0,
  createProjectMemberList: [], // 과제 추가시 등록할 멤버
  projectFavoriteList: [],
  selectedFolder: [],
  paperRegUser: "", // 보드 생성자
};
const actions = {};
const mutations = {
  setProjectFavoriteList(state, payload) {
    state.projectFavoriteList = payload;
  },
  setProjectOkrLinkCount(state, payload) {
    state.projectOkrLinkCount = payload;
  },
  setProjectOkrLinkList(state, payload) {
    state.projectOkrLinkList = payload;
  },
  setCreateProjectMemberList(state, payload) {
    state.createProjectMemberList = payload;
  },
  setProjectInvitationMemberList(state, payload) {
    state.projectInvitationMemberList = payload;
  },
  setProjectInvitationMemberCount(state, payload) {
    state.projectInvitationMemberCount = payload;
  },
  setProjectMemberList(state, payload) {
    if(i18nUtil.getLanguage() === 'ko') {
      
    }else{
      payload.forEach(member => {
        member.userName = member.userNameEn;
        member.deptName = member.deptNameEn;
        member.companyName = member.companyNameEn;
        member.jobPositionName = member.jobPositionNameEn;
        member.jobFunctionName = member.jobFunctionNameEn;
      })
    }
    state.projectMemberList = payload;
  },
  setProjectMemberCount(state, payload) {
    state.projectMemberCount = payload;
  },
  setProjectCommentCount(state, payload) {
    state.projectCommentCount = payload;
  },
  setProjectList(state, payload) {
    state.projectList = payload;
  },
  setPaperCount(state, payload) {
    state.complPaperCount = payload.complPaperCount;
    state.ingPaperCount = payload.ingPaperCount;
    state.pausePaperCount = payload.pausePaperCount;
    state.totalPaperCount = payload.totalPaperCount;
    state.decisionCount = payload.decisionCount;
  },
  setProjectInfo(state, payload) {
    state.projectInfo = payload;
  },
  setProjectListAll(state, payload) {
    state.projectListAll = payload;
  },
  setSelectedFolder(state, payload) {
    state.selectedFolder = payload;
  },
  setPaperRegUser(state, payload) {
    state.setPaperRegUser = payload;
  }
};
const getters = {};

export default { state, actions, mutations, getters, namespaced: true };



// WEBPACK FOOTER //
// ./src/js/store/module/project/project.js